<template>
  <div id="main-page">
    <section-definition :title="page.title" ></section-definition>

    <v-container fluid grid-list-xl page>
      <v-layout row wrap>
        <v-flex grow></v-flex>



        <v-flex xs4 sm4 md2>
          <v-menu
              v-model="date_menu1"
              :close-on-content-click="false"
              :nudge-right="0"
              lazy
              transition="scale-transition"
              offset-y
              :nudge-bottom="0"
              full-width
              max-width="290px"
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_begin"
                      label="Begin Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"
                      v-on:change="on_select_dealership"
              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_begin"
                    no-title
                    @input="date_menu1 = false"
                    v-on:change="on_select_dealership"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs4 sm4 md2>
          <v-menu
                  v-model="date_menu2"
                  :close-on-content-click="false"
                  :nudge-right="0"
                  lazy
                  transition="scale-transition"
                  offset-y
                  :nudge-bottom="0"
                  full-width
                  max-width="290px"
                  min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_end"
                      label="End Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_end"
                    no-title
                    @input="date_menu2 = false"
                    v-on:change="on_select_dealership"
            ></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm6 md4>

          <v-autocomplete
                  label="Organization/Dealership"
                  :items="dealerships"
                  item-value="_id"
                  item-text="txt"
                  v-model="selectedDealership"
                  v-on:change="on_select_dealership"
          >
          </v-autocomplete>

        </v-flex>
      </v-layout>


      <v-container fluid grid-list-md page>
        <v-layout>

          <!----------------------------------------card for overall dealer grade-------------------------------------->
          <v-flex xs12 sm4 v-if="!sp_mode">
            <v-card @click="on_select_dealership" style="cursor: pointer">
              <v-toolbar color="transparent" flat>
                <v-toolbar-title>Dealership Grade</v-toolbar-title>
              </v-toolbar>
              <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
              <v-card-text class="text-xs-center">
                <v-progress-circular
                        :rotate="0"
                        :value="100"
                        :size="240"
                        :width="15"
                        :color="get_grade_color(gradeIxToLetter(grade_dealership.avg_grade_ix))"
                >
                  <span class="grade-card"><strong>{{gradeIxToLetter(grade_dealership.avg_grade_ix)}}</strong> </span><br>
                  <span class="grey--text">Average Grade</span>
                </v-progress-circular>
                <div class="title my-2">Date Range</div>
                <span class="subheading grey--text">{{selected_date_begin}} to {{selected_date_end}}</span>
              </v-card-text>
            </v-card>
          </v-flex>


          <!---------------------------card to list average grade of sales people-------------------------------------->
          <v-flex xs12 sm8 v-if="!sp_mode">
            <v-card max-height="396px" style="overflow: auto">
              <v-toolbar color="transparent" flat>
                <v-toolbar-title>Sales Person Ranking</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small  @click="on_select_dealership">Reset Data</v-btn>
              </v-toolbar>
              <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
              <v-card-text class="text-xs-left">

                <v-data-table
                        :headers="sp_headers"
                        :items="grades_salesPeople"
                        :pagination.sync="sp_pagination"
                        hide-actions


                >
                  <template slot="items" slot-scope="props" >
                    <tr
                            class="row_style"
                            style="cursor:pointer;"
                            @click="on_select_salesPerson(props.item)"
                            :key="props.item.user_id"
                    >
                      <td >
                        <v-avatar slot="activator" size="40">
                          <img
                                  v-if="props.item.picture !== ''"
                                  :src="props.item.picture">
                        </v-avatar>
                      </td>
                      <td>{{ props.item.name }}</td>
                      <td>{{ props.item.curriculum.name}}</td>
                      <td>{{ gradeIxToLetter(props.item.avg_grade_ix)}}</td>
                      <!--<td>{{ props.item.avg_score }}</td>-->
                      <td>{{ props.item.count }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>









        <!----------------------Over all letter grade--------------------------------->
        <v-layout>
          <v-flex xs12>
            <v-card>
              <v-card-title class="card-title">Overall Grade Trend</v-card-title>
              <timeseries
                      v-if="chartData_letterGrades != null"
                      :chartdata="chartData_letterGrades"
                      :click-handler="on_click_chart_data"
              ></timeseries>

            </v-card>
          </v-flex>

        </v-layout>










        <!----------------------chart for email response time------------------------------>
        <v-layout>
          <v-flex xs12>
            <v-card class="mt-9">
              <v-card-title class="card-title">Email Response Time</v-card-title>
              <timeseries
                      v-if="chartData_emailResponse != null"
                      :chartdata="chartData_emailResponse"
                      :click-handler="on_click_chart_data"
              ></timeseries>
              <v-card-text v-else>
                No data for this question
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>



        <!----------------------chart for call response time------------------------------>
        <v-layout>
          <v-flex xs12>
            <v-card class="mt-9">
              <v-card-title class="card-title">Call Response Time</v-card-title>
              <timeseries
                      v-if="chartData_callResponse != null"
                      :chartdata="chartData_callResponse"
                      :click-handler="on_click_chart_data"
              ></timeseries>
              <v-card-text v-else>
                No data for this question
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>


        <v-layout>
          <v-flex xs12>
            <v-card class="mt-9">
              <v-card-title class="card-title">Confirmed Price On New</v-card-title>
              <timeseries
                      v-if="chartData_pricingNew != null"
                      :chartdata="chartData_pricingNew"
                      :click-handler="on_click_chart_data"
              ></timeseries>
              <v-card-text v-else>
                No data for this question
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>


        <v-layout >
          <v-flex xs12>
            <v-card class="mt-9">
              <v-card-title class="card-title">Confirmed Price On Used</v-card-title>
              <timeseries
                      v-if="chartData_pricingUsed != null"
                      :chartdata="chartData_pricingUsed"
                      :click-handler="on_click_chart_data"
              ></timeseries>
              <v-card-text v-else>
                No data for this question
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>






        <!------------------------------list of individual graded leads------------------------------------------------>
        <!--<v-layout v-if="show_graded_leads">-->
          <!--<v-flex xs12>-->
            <!--<v-card>-->
              <!--<v-toolbar color="transparent" flat>-->
                <!--<v-toolbar-title>Graded Leads For: {{selectedSalesPerson ? selectedSalesPerson.name : ''}}</v-toolbar-title>-->
                <!--<v-spacer></v-spacer>-->
                <!--<v-btn icon>-->
                  <!--<v-icon>more_horiz</v-icon>-->
                <!--</v-btn>-->
              <!--</v-toolbar>-->
              <!--&lt;!&ndash; <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> &ndash;&gt;-->
              <!--<v-card-text class="text-xs-left">-->

                <!--<v-data-table-->
                    <!--:headers="gl_headers"-->
                    <!--:items="graded_leads"-->
                <!--&gt;-->
                  <!--<template slot="items" slot-scope="props" >-->
                    <!--<tr  v-on:click="view_this_grade(props.item)" style="cursor:pointer;">-->
                      <!--<td>{{ props.item.info_lead.lead_arrived_date }}</td>-->
                      <!--<td>{{ props.item.date_graded.slice(0, 10) }}</td>-->
                      <!--<td>{{ props.item.curriculum.name }}</td>-->
                      <!--<td>{{ props.item.grade_letter }}</td>-->
                      <!--<td>{{ round(props.item.grade_score, 1) }}</td>-->
                      <!--<td>{{ props.item.info_customer.name_first +' ' + props.item.info_customer.name_last}}</td>-->
                      <!--<td>{{ props.item.info_lead.wanted_vehicle }}</td>-->
                      <!--<td>{{ truncate_str(props.item.comments_external) }}</td>-->
                      <!--<td v-if="gl_headers.length === 9">-->
                        <!--<v-icon small color="error" @click.stop="del_grade(props.item)">delete</v-icon>-->
                      <!--</td>-->
                    <!--</tr>-->
                  <!--</template>-->
                <!--</v-data-table>-->
              <!--</v-card-text>-->
              <!--</v-card>-->

          <!--</v-flex>-->

        <!--</v-layout>-->




        <v-dialog v-model="showGrade" max-width="900px" attach="#main-page" >
          <view-grade
                  v-if="showGrade"
                  :graded_lead="selectedLead"
                  @close-parent="showGrade=false"
          ></view-grade>
        </v-dialog>



      </v-container> <!--main container-->
    </v-container>









  </div>
</template>


<style scoped>
  .grade-card{
    font-size: xx-large;
    font-weight: bolder;
    /*color: black;*/
  }

  .row_style{
    text-align: left;
    border: none !important;
    font-size: large;
  }

  .card-title{
    font-size: x-large;

  }
</style>


<script>
   import axios from 'axios';
   const moment = require('moment');
   import viewGrade from '../components/viewGrade.vue';
   import data_getters from '../mixins/data_getters'
   import {DateTime} from 'luxon';
   import regression from 'regression';
   import wrapText from 'wrap-text';

   import timeseries from '../components/echart.vue';

   import {
      ma, dma, ema, sma, wma
   } from 'moving-averages'




   // function findWithAttr(array, attr, value) {
   //    for(var i = 0; i < array.length; i += 1) {
   //       if(array[i][attr] === value) {
   //          return i;
   //       }
   //    }
   //    return -1;
   // }

   let now = moment();


export default {
   components:{
      viewGrade,
      timeseries,
   },

   mixins: [data_getters],

  data() {
     return {
        letter_grades: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'],
        date_menu1: false,
        date_menu2: false,
        // selected_date_begin:   moment().subtract(90, 'days').format('YYYY-MM-DD'),
        selected_date_begin:   moment().subtract(90, 'days').startOf('month').format('YYYY-MM-DD'),
        selected_date_end:   moment().format('YYYY-MM-DD'),

        dealerships: [],
        selectedDealership: null,
        salesPeople: [],
        selectedSalesPerson: null,

        grade_dealership: {},
        grades_salesPeople: [],
        graded_leads: [],

        selectedLead: null,
        showGrade: false,

        sp_headers: [
           {text: '', value: 'picture', width: '5%'},
           {text: 'Sales Person', value: 'name', width: '20%'},
           {text: 'Curriculum', value: 'curriculum.name', width: '20%'},
           {text: 'Avg Grade', value: 'avg_grade_ix', width: '20%'},
           // {text: 'Avg Score', value: 'avg_score', width: '20%'},
           {text: '# Leads Graded', value: 'count', width: '20%'},

        ],
        sp_pagination: {
           sortBy: 'count', // The field that you're sorting by
           descending: true,
           rowsPerPage: -1
        },


        gl_headers_non_admin: [
           {text: 'Date In', value: 'info_lead.lead_arrived_date', width: '10%'},
           {text: 'Date Graded', value: 'date_graded', width: '10%'},
           {text: 'Curriculum', value: 'curriculum.name', width: '5%'},
           {text: 'Grade', value: 'grade_letter', width: '5%'},
           {text: 'Score', value: 'grade_score', width: '5%'},
           {text: 'Customer', value: 'count', width: '15%'},
           {text: 'Vehicle', value: 'info_lead.wanted_vehicle', width: '15%'},
           {text: 'Comments', value: 'comments_external', width: '45%'},
        ],

        gl_headers_admin: [
           {text: 'Date In', value: 'info_lead.lead_arrived_date', width: '10%'},
           {text: 'Date Graded', value: 'date_graded', width: '10%'},
           {text: 'Curriculum', value: 'curriculum.name', width: '5%'},
           {text: 'Grade', value: 'grade_letter', width: '5%'},
           {text: 'Score', value: 'grade_score', width: '5%'},
           {text: 'Customer', value: 'count', width: '15%'},
           {text: 'Vehicle', value: 'info_lead.wanted_vehicle', width: '15%'},
           {text: 'Comments', value: 'comments_external', width: '45%'},
           {text: '', value: '', width: '5%'},

        ],

        dialog_delete_grade: false,
        del_grade_id: null,


        gl_pagination: {
           sortBy: 'avg_score', // The field that you're sorting by
           descending: true,
           rowsPerPage: -1
        },

        page: {
           title: "Report Card",
        },

        chartData_letterGrades:  null,
        chartData_callResponse:  null,
        chartData_emailResponse:  null,
        chartData_pricingNew:  null,
        chartData_pricingUsed:  null,

     };
  },



  methods:{


     /**
      * creates chart data for tracking trend on specific question
      * @param leads    : array of graded leads, possibly filtered (return object from filter_grades_by_tags() )
      * @param f        : function f(x), x = graded lead, returns a value that's in y_labels
      * @param y_labels : Array of labels, basically the answers list to the the question that we're showing
      */

     get_chart_data (leads, f, y_labels, {reverse_labels=false, label_width=100} = {}) {
        let n = leads.length;
        let n_labels = y_labels.length;

        y_labels = JSON.parse(JSON.stringify(y_labels));

        if (reverse_labels){
           y_labels.reverse();
        }

        console.log('y_labels', y_labels);


        let data = [];
        let reg_data = [];
        let salespeople = {};

        let x=[], y=[];
        for (let i=0; i<n; i++){

           let ix = y_labels.indexOf(f(leads[i]));
           if (ix === -1){
              console.log('debug', leads[i])
           }
           y.push(ix+1);

           let tmp = DateTime.fromISO(leads[i].info_lead.lead_arrived_date);
           tmp = tmp.toMillis();
           x.push(tmp);

           reg_data.push([x[i], y[i]]);
           data.push({value: [x[i], y[i]]});

           let email = leads[i].sales_people[0].email;

           let d = [x[i], y[i], leads[i]._id];
           if (email in salespeople){
              salespeople[email].data.push(d);
           }
           else{
              salespeople[email] = {
                 name: leads[i].sales_people[0].name,
                 type: 'scatter',
                 data: [d],
                 yAxisIndex: 0,
              };
           }
           // salespeople.add();
        }

        let reg = regression.linear(reg_data, {precision: 15});
        console.log(reg.string);
        let trend = reg.points;

        //convert object to array for echarts
        let series = [];
        let keys = Object.getOwnPropertyNames(salespeople);

        let legend = [];
        for (let i=0; i<keys.length; i++){
           series.push(salespeople[keys[i]]);
           legend.push(salespeople[keys[i]].name);
        }

        if (series.length === 1){
           series[0].itemStyle = {color: '#881eff'};
        }

        series.push({
           name: 'Trend',
           type: 'line',
           data: trend,
           yAxisIndex: 0,
           symbol: 'circle',
           symbolSize: 0,
           itemStyle: {
              color: '#747474'
           },
           lineStyle: {
              width: 3,
              color: '#747474'
           }
        });
        legend.push({name: 'Trend', color: '#747474', });






        //combine y labels if neccesary
        let y_labels_disp = JSON.parse(JSON.stringify(y_labels));
        for (let i=0; i<y_labels_disp.length; i++){
           y_labels_disp[i] = wrapText(y_labels[i], 13 );
        }


        let chart_settings = {
           grid: {
              left: '5%',
              top: 10,
              right: label_width,
              bottom: '20%'
           },
           tooltip: {show: true},
           legend: {
              data: legend,
              top: 'bottom',
           },
           xAxis: {
              type: 'time',
              axisLabel: {
                 // fontSize: 20
              }
           },
           yAxis: [
              {
                 type: 'value',
                 max: n_labels+0.3,
                 min: 0,
                 minInterval: 1,
                 axisLabel: {
                    fontSize: 10,
                    formatter: function(value, index){
                       return '';
                    }

                 }
              },
              {
                 type: 'value',
                 max: n_labels+0.3,
                 min: 0,
                 minInterval: 1,
                 axisLabel:{
                    formatter: function(value, index){
                       if (Math.abs(Math.round(value) - value) < 0.01){

                          return y_labels_disp[Math.round(value)-1];
                       }
                       else return '';

                    },
                    fontSize: 14
                 },
              },



           ],
           series: series,
        };

        return chart_settings;
     },












     /**
      * Click handler for echarts
      * Note assumes that the data properties, third element is the lead_id
      *
      * @param event : the event object passed in from echarts 'click' event
      */
     on_click_chart_data(event){

        // console.log('event', event)
        let lead_id = event.data[2];

        let ix = this.findWithAttr(this.graded_leads, '_id', lead_id);


        this.selectedLead = this.graded_leads[ix];
        this.showGrade=true;


     },



     async get_dealers_local(){


        try {
           // let {data} = await axios.get(url, token);
           this.dealerships = await this.get_dealers();

           for (let i=0; i<this.dealerships.length; i++){
              let d = this.dealerships[i];
              if (d.org_id){
                 this.dealerships[i].txt = d.org_id.name +' / '+d.name;
              }
              else{
                 this.dealerships[i].txt ='No Group/'+d.name;
              }
           }//for i

           this.dealerships = this.dealerships.sort((a, b) => (a.txt > b.txt) ? 1 : -1);


        }
        catch(err){
           console.log(err);
           // ans = err.response.data;
        }
     },

     async on_select_dealership(){

        if (this.sp_mode){
           this.selectedSalesPerson = this.$auth.profile;
           this.get_graded_leads_local(this.$auth.profile.user_id);
        }
        else{
           await this.get_reportCardData();
           this.selectedSalesPerson = null;
           this.get_graded_leads_local();
        }
     },


     async on_select_salesPerson(sp){
        this.selectedSalesPerson = sp;

        this.get_graded_leads_local(sp.user_id)
     },





     view_this_grade(grade){
        this.selectedLead = grade;
        this.showGrade=true;


     },


     /**
      * helper that filters list of grades based on tags.
      * NOTE: The get_q_data must be set to true in the get_graded_leads() call
      * @param leads    : array of graded leads
      * @param q_filter : string|array
      *
      * returns filters list of graded leads, with the questions
      */
     filter_grades_by_tags(leads, tags){
        // let ans = JSON.parse(JSON.stringify(leads));
        let ans2 = [];
        if (typeof tags === 'string'){
           tags = [tags];
        }


        // for each graded lead
        for (let i=0; i<leads.length; i++){

           //go through and find the question that matches the tags
           for (let j=0; j < leads[i].questions.length; j++){

              //then create a version of the lead with only that question.
              if (tags.some(x =>  leads[i].questions[j].question_id.tags.includes(x))){
                 let tmp = JSON.parse(JSON.stringify(leads[i]));
                 tmp.filtered_question =  leads[i].questions[j];
                 delete tmp.questions;
                 ans2.push(tmp);
                 break;
              }
           }


        }//for i

        return ans2;

     },



     async get_graded_leads_local(user_id){

        let dateRange = {begin: this.selected_date_begin, end: this.selected_date_end };

        /**
         * call back function passed to get_chart_data().
         * Returns the answer index of first email response time question
         */
        function get_ans(g){
           return g.filtered_question.answer;
        }

        function get_grade(g){
           return g.grade_letter;
        }




        try {
           if (this.selectedDealership){


              //********get data for overall grade***************************
              if (user_id != undefined){
                 this.graded_leads = await this.get_graded_leads({user_id, dateRange, dealer_id: this.selectedDealership,
                                                                 get_q_data: true});
              }
              else{
                 this.graded_leads = await this.get_graded_leads({dateRange, dealer_id: this.selectedDealership,                     get_q_data: true});
              }

              this.graded_leads.sort((a, b) => (a.info_lead.lead_arrived_date > b.info_lead.lead_arrived_date) ? 1: -1);
              // this.fillData(this.graded_leads);

              let y_labels_g = this.letter_grades;

              this.chartData_letterGrades =  this.get_chart_data(this.graded_leads, get_grade, y_labels_g,
                 {reverse_labels: true, label_width: 50});



              //********get data for email***************************
              let email_questions = this.filter_grades_by_tags(this.graded_leads, 'JS-RESPONSE-EMAIL');
              // console.log('email_questions', email_questions)
              if (email_questions.length>0){
                 let y_labels = email_questions[0].filtered_question.question_id.answers.map(x => x.ans);
                 this.chartData_emailResponse =  this.get_chart_data(email_questions, get_ans, y_labels, {label_width:120});
              }
              else{
                 this.chartData_emailResponse = {};
              }


              //********get data for call question***************************
              let call_questions = this.filter_grades_by_tags(this.graded_leads, 'JS-RESPONSE-CALL');
              if (call_questions.length>0){
                 // console.log('call_questions', call_questions)
                 let y_labels2 = call_questions[0].filtered_question.question_id.answers.map(x => x.ans);
                 this.chartData_callResponse =  this.get_chart_data(call_questions, get_ans, y_labels2, {label_width:120});
              }
              else{
                 this.chartData_callResponse = {};
              }


              //********get data for pricing new***************************
              let pricingNew_questions = this.filter_grades_by_tags(this.graded_leads, 'JS-RESPONSE-PRICE-NEW');
              if (pricingNew_questions.length>0){
                 // console.log('call_questions', call_questions)
                 let y_labels2 = pricingNew_questions[0].filtered_question.question_id.answers.map(x => x.ans);
                 this.chartData_pricingNew =  this.get_chart_data(pricingNew_questions, get_ans, y_labels2,
                    {label_width:120,  reverse_labels: true,});
              }
              else{
                 this.chartData_pricingNew = {};
              }

              //********get data for pricing used***************************
              let pricingUsed_questions = this.filter_grades_by_tags(this.graded_leads, 'JS-RESPONSE-PRICE-USED');
              if (pricingUsed_questions.length>0){
                 // console.log('call_questions', call_questions)
                 let y_labels2 = pricingUsed_questions[0].filtered_question.question_id.answers.map(x => x.ans);
                 this.chartData_pricingUsed =  this.get_chart_data(pricingUsed_questions, get_ans, y_labels2,
                    {label_width:120,  reverse_labels: true,});
              }
              else{
                 this.chartData_pricingUsed = null;
              }

           }

        }
        catch(err){
           console.log(err);
           // ans = err.response.data;
        }
     },




     async get_reportCardData(){

        if (this.selectedDealership === undefined)
           return;


        let {token, query} = await this.base_user_request();
        let url = this.$baseUrlApi + '/getReportCardData';

        query.dealer_id = this.selectedDealership;

        let payload = {
           match: query,
           dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
           groupby: 'dealership',
           user_role: 'SalesPerson',
        };

        let payload2 = {
           match: query,
           dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
           groupby: 'salesperson',
           user_role: 'SalesPerson',
           sp_only_active: false,
        };


        try {
           if (this.selectedDealership){
              let {data} = await axios.post(url, payload, token);

              if (data.length===1){
                 this.grade_dealership = data[0];
              }
              else{
                 this.grade_dealership = {avg_grade_ix: -1}
              }


              let res = await axios.post(url, payload2, token);
              this.grades_salesPeople = res.data;

           }

        }
        catch(err){
           console.log(err);
           this.avg_grade_ix = -1;

        }
     },





     gradeIxToLetter(ix){
        if (ix>-1){
           return this.letter_grades[Math.round(ix)];
        }
        else{
           return 'N/A';
        }
     },

     get_grade_color(grade){
        let ans;
        switch (grade.charAt(0)){
           case 'A':
              ans =  '#00C853';
              break;
           case 'B':
              ans =  '#F9A825';
              break;
           case 'C':
              ans =  '#F9A825';
              break;
           case 'D':
              ans =  '#D50000';
              break;
           case 'F':
              ans =  '#D50000';
              break;
           case 'N':
              ans =  '#9E9E9E';
              break;

        }
        return ans;
     }
  },
   computed: {
     sp_mode(){
        return this.$auth.profile.user_role === 'SalesPerson';
     },

      show_graded_leads(){
        if (this.$auth.profile.user_role !== 'SalesPerson'){
           return !!this.selectedSalesPerson;
        }
        else{
           return true;
        }

      },

      gl_headers(){

         if (this.$auth.profile.user_role === 'Admin' && this.$auth.profile.acct_type === 'AGENCY'){
            return this.gl_headers_admin;
         }
         else{
            return this.gl_headers_non_admin;
         }
      }

   },

  async created(){

     // this.fillData();



     await this.get_dealers_local();

     if (this.dealerships[0]){
        this.selectedDealership = this.dealerships[0]._id;
        await this.on_select_dealership();
     }






     // if (this.sp_mode){
     //    this.selectedSalesPerson = this.$auth.profile;
     //    this.get_graded_leads_local(this.$auth.profile.user_id);
     // }
     // else{
     //    // this.get_graded_leads_local();
     // }


  }
};
</script>
